import React from "react";
import {Loader} from "../../components/Loader";
import {ListComponent} from "../../components/ListComponent";
import {FormGroup} from "../../components/FormComponent/FormGroup";
import {TableFooter} from "../../components/ListComponent/TableFooter";
import {Util} from "../../components/Util";
import {FormattedNumber} from "../../components/Elements/FormattedNumber";
import {DateTime} from "../../components/ListComponent/DateTime";
import {Dictionary} from "../../components/Dictionary";
import Info from "../../components/FormComponent/FormGroup/Info";
import {TBody} from "../../components/Table/TBody";

export class MissingProducts extends ListComponent {
    private item: any = null;

    protected getRequestUrl(): RequestInfo | URL {
        return '/product/missing';
    }

    render() {
        if (!this.state) {
            return <Loader/>;
        }

        const params: {} | any = this.getFormData(),
            dictionary: Dictionary = this.dictionary;

        this.state?.item && (this.item = this.state?.item);

        return (
            <>
                <div className="row">
                    <form className="x-form" method="POST" onSubmit={this.handleSubmit}>
                        <div className="row">
                            <h5>{this.dictionary.get['search']}</h5>
                            <div className="col-12">
                                <Info>
                                    {this.dictionary.get['product-missing-info']}
                                </Info>
                            </div>
                        </div>
                        <div className="row">

                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Input {...{id: 'search', defaultValue: params?.search}}/>
                            </div>

                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Input {...{id: 'id', defaultValue: params?.id}}/>
                            </div>

                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Input {...{id: 'product_id', defaultValue: params?.product_id}}/>
                            </div>

                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Input {...{id: 'sku', defaultValue: params?.sku}}/>
                            </div>
                        </div>

                        <input type="hidden" name="sort" defaultValue={params.sort ?? 'd.id:d'}/>
                        {this.listOfSearchParams(params)}

                        <div className="row">
                            <div className="col-12 caption">
                                <button className="btn btn-sm btn-primary" type="submit">
                                    {this.dictionary.get['search']}
                                </button>
                                &nbsp;
                                <h6>
                                    {this.dictionary.get['missing-products']}: &nbsp;
                                    <strong>{this.state.count ? this.state.count : '-'}</strong> {this.dictionary.get['pc']}
                                </h6>
                            </div>
                        </div>
                        <div className="row" style={{marginBottom: '10px'}}>
                            <div className="col-6 col-sm-6 col-md-4 col-xl-3 col-xxl-2" key={TBody.index++}>
                                {this.dictionary.get['item_count']}&nbsp;
                                <FormattedNumber value={this.state?.item?.item_count}/>
                                &nbsp;{dictionary.get['pc']}
                            </div>
                            <div className="col-6 col-sm-6 col-md-4 col-xl-3 col-xxl-2" key={TBody.index++}>
                                {this.dictionary.get['quantity']}&nbsp;
                                <FormattedNumber value={this.state?.item?.increment_quantity}/>
                                &nbsp;{dictionary.get['pc']}
                            </div>
                        </div>
                    </form>
                </div>

                <div className="row">
                    <div className="table-responsive">
                        <table className="table table-hover table-sm align-middle">
                            <thead>
                            <tr>
                                <th className="sortable" data-sortkey="d.id" style={{textAlign: 'right'}}>
                                    MID <i className="bi bi bi-sort-down"></i>
                                </th>
                                <th className="sortable" data-sortkey="i.id" style={{textAlign: 'right'}}>
                                    IID
                                </th>
                                <th style={{textAlign: 'right'}}>{this.dictionary.get['transfer-product']}</th>
                                <th style={{textAlign: 'right'}}>{this.dictionary.get['product_id']}</th>
                                <th style={{textAlign: 'right'}}>{this.dictionary.get['sku']}</th>
                                <th>{this.dictionary.get['product_name']}</th>
                                <th style={{textAlign: 'right'}}>{this.dictionary.get['quantity']}</th>
                                <th>{this.dictionary.get['created_at']}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.items.map(function (elem: any) {
                                return (
                                    <tr key={elem.item_id}>
                                        <td style={{textAlign: 'right'}}>{elem.id}</td>
                                        <td style={{textAlign: 'right'}}>{elem.item_id}</td>
                                        <td style={{textAlign: 'right'}}>{elem.transfer_product_id ? Util.link(elem.transfer_product_id, '/transfer-product/details/' + elem.transfer_product_id) : '-'}</td>
                                        <td style={{textAlign: 'right'}}>{Util.link(elem.product_id, '/product/details/' + elem.product_id)}</td>
                                        {Util.searchCell(elem.sku, 'sku', {style:{textAlign: 'right'}})}
                                        <td>{elem.product_name}</td>
                                        <FormattedNumber value={elem.increment_quantity}
                                                         parentNode="td" suffix={dictionary.get['pc']}
                                                         style={{textAlign: 'right'}}/>
                                        <td><DateTime value={elem.created_at} inline={true}/></td>
                                    </tr>
                                )
                            })}
                            </tbody>
                            {this.state.itemsCount < this.limit ? (
                                <TableFooter colspan={8}/>
                            ) : ''}
                        </table>
                        {this.state.isLoading && <Loader/>}
                    </div>
                </div>
            </>
        )
            ;
    }
}
